export const themes = [
  {
    primary: "#D42022",
    secondary: "#04bbff",
    tertiary: "#fff200"
  }
];

export const colors = {
  ...themes[0],
  black: "#202020",
  white: "#FFF",
  lightGrey: "#f1f2f2",
  gray: "#F2F1F1",
  shade: "#8A8A8A",
  cold: "#b4f7ec",
  newCold: "#86FCEC",
  coldDark: "#79DACA",
  coldLight: "#E7FEFB",
  mint: "#dcfbd8",
  line: "#a09c9c",
  darkLine: "#878484",
  labelFocus: "#65ecda",
  red: "#ff6a6a",
  darkGreen: "#1A3224",
  green: "#43934F",
  darkBlue: "#29275D",
  blue: "#85C6E3",
  yellow: "#FFF151",
  grayTrans: "rgba(242,241,241,0.9)"
};



// WEBPACK FOOTER //
// ./src/theme.js